import { searchResultComponent } from './search-result.component';
import { SearchResultService } from './search-result.service';
import './search-result.scss';

export const searchResult = angular
    .module('components.searchResult', [])
    .component('searchResultComponent', searchResultComponent)
    .config(($stateProvider) => {
        'ngInject';

        $stateProvider
            .state('SearchResults', {
                url: '/search/:searchKey',
                component: 'searchResultComponent',
                breadcrumbName: 'Search Results',
                parentState: 'Home',
                resolve: {
                    details($stateParams, SearchResultService) {
                        'ngInject';

                        return SearchResultService.getSearchResults($stateParams.searchKey)
                    },
                    searchKey($stateParams) {
                        'ngInject';

                        return $stateParams.searchKey
                    },
                    breadcrumb(BreadcrumbService) {
                        'ngInject';

                        const breadcrumb = [{
                            name: "Search",
                            display_name: "Search",
                            slug: ""
                        }];

                        BreadcrumbService.setPageBreadcrumbs(breadcrumb);
                    }
                }
            });
    })
    .service('SearchResultService', SearchResultService)
    .name;


// WEBPACK FOOTER //
// ./src/app/components/search-result/search-result.module.js